import { PlanogramProductDetailSchema } from "@labeling-tools/api/atlas/types.gen";
import { Loader } from "@mantine/core";

export const PlanogramProduct = ({
  selectedProduct,
  loading,
}: {
  selectedProduct?: PlanogramProductDetailSchema;
  loading?: boolean;
}) => {
  return (
    <div className="p-4 max-w-[400px] h-[200px]">
      {selectedProduct ? (
        <>
          <div className="flex justify-center relative">
            <div className="absolute top-0 left-0 text-xs text-gray-500">
              Facings: {(selectedProduct?.metadata as any)?.facings ?? 0}
            </div>
            <div className="size-36 bg-white">
              {!!selectedProduct?.image_url && (
                <img
                  src={selectedProduct?.image_url}
                  className="size-full object-contain"
                />
              )}
            </div>
          </div>

          <div className="h-4" />

          {!!selectedProduct?.description && (
            <>
              <div className="space-y-2 text-xs">
                <div className="font-semibold">
                  {selectedProduct?.description}
                </div>
              </div>
            </>
          )}
        </>
      ) : loading ? (
        <div className="flex justify-center items-center h-full">
          <Loader />
        </div>
      ) : null}
    </div>
  );
};
